export default {
  // 主页面
  collaborationPage: 'Collaboration',
  coldEmail: 'Cold email',
  reportAndPayout: 'Report & Payout',
  report: 'Report',
  budgetLabel: 'Budget',
  campaignInfoPage: 'Campaign info',
  campaignInfo: 'Campaign info',
  
  // 状态相关
  status: {
    active: 'Active',
    paused: 'Paused',
    draft: 'Draft',
    ended: 'Ended',
    predicting: 'Predicting',
    completed: 'Completed',
    cancelled: 'Cancelled',
    reviewing: 'Under review',
    rejected: 'Rejected'
  },
  
  // 操作按钮
  actions: {
    pause: 'Pause',
    resume: 'Resume',
    edit: 'Edit',
    close: 'Close',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    reset: 'Reset',
    back: 'Back'
  },
  
  // 预算相关
  budget: {
    title: 'Budget',
    currentBudget: 'Current Budget',
    remainingBudget: 'Remaining Budget',
    spentBudget: 'Spent Budget',
    changeBudget: 'Change Budget',
    budgetLimit: 'Budget Limit',
    monthlyBudget: 'Monthly Budget',
    totalBudget: 'Total Budget',
    influencerBudget: 'Influencer Budget',
    affiliateBudget: 'Affiliate Budget',
    coldEmailBudget: 'Cold Email Budget',
    continueBudget: 'Continue Budget',
    cancelBudget: 'Cancel Budget',
    updateBudget: 'Update Budget',
    budgetHistory: 'Budget History',
    budgetCycle: 'Budget Cycle',
    nextCycle: 'Next Cycle',
    currentCycle: 'Current Cycle'
  },
  
  // 反馈相关
  feedback: {
    title: 'Feedback',
    submitFeedback: 'Submit feedback',
    submitFeedbackHere: 'Submit feedback here',
    pleaseEnterFeedback: 'Please enter feedback',
    feedbackPlaceholder: 'Let me know how I can optimize the influencer matching results for this campaign!',
    feedbackSubmitted: 'Feedback submitted successfully',
    submitNewFeedback: 'Submit new feedback',
    sendFeedback: 'Send feedback'
  },
  
  // 指南卡片
  guide: {
    title: 'Campaign Guide',
    description: 'Learn how to optimize your campaign performance',
    viewGuide: 'View Guide',
    instructions: 'Instructions'
  },
  
  // 暂停相关
  pause: {
    resumeCampaign: 'Resume Campaign',
    title: "Your campaign",
    title2: "has been paused due to inactivity.",
    content: "To continue matching with influencers and keep things moving, you can resume the campaign now.",
  },
  
  // 预算不足提醒
  budgetAlert: {
    title: 'Budget Alert',
    insufficientBudget: 'Insufficient budget for current cycle',
    addBudget: 'Add Budget',
    upgradePlan: 'Upgrade Plan',
    lowBudgetTitle: '“{name}” is low on budget: {costToDate} of {campaignBudget} spent',
    lowBudgetDesc: 'Your budget directly limits how many influencers can be invited. Raise it today to unlock more collaborations and maximize your results.',
    pausedTitle: 'This campaign is currently paused',
    pausedDesc: 'If you need help optimizing your campaign setup or launching a new campaign, please contact our Customer Support team anytime.'
  },

  // 预算页面相关
  budgetPage: {
    title: 'Budget',
    renewalSuccessful: 'Renewal successful!',
    accountFrozen: 'Your account has been frozen',
    changeSuccess: 'Budget changed successfully',
    cancelSuccess: 'Campaign canceled successfully',
    raiseMaxCpm: 'Raise maximum CPM to fully use your ad budget',
    currentAdSpend: 'Current ad spend: {cost}',
    youtubeDedicated: 'YouTube dedicated: {price}',
    youtubeIntegrated: 'YouTube integrated: {price}',
    tiktokVideo: 'TikTok video: {price}',
    influencerMarketingBudget: 'Influencer marketing budget',
    viewBillingHistory: 'View billing history',
    costToDate: 'Cost to date',
    costToDateDescription: 'Includes influencer payment, platform fee, and applicable transaction fees.',
    budget: 'Budget',
    budgetTooltip: 'Your budget determines how many influencers AhaCreator can invite.',
    currencyUnit: 'USD',
    affiliateRecruitmentBudget: 'Affiliate recruitment budget',
    continueWithBudget: 'Continue with {budget} budget',
    continueAndModify: 'Continue & Modify the budget',
    cancel: 'Cancel',
    renewCampaign: 'Renew campaign',
    coldEmailBudget: 'Cold email budget',
    continueModifyTitle: 'Continue & Modify the budget',
    confirm: 'Confirm',
    monthlySpendingLimit: 'Your monthly spending limit is the maximum you\'ll spend on a campaign in one month. We will deduct charges as we confirm the expected clicks within the current month.',
    termination: 'Termination',
    cancelCampaign: 'Cancel this campaign?',
    cancelCampaignDesc: 'After the activity is canceled, it cannot be recovered. Please operate with caution.',
    change: 'CHANGE',
    yes: 'Yes',
    no: 'No',
    instagramReel: 'Instagram Reels: {price}',
    twitterPost: 'Twitter / X posts: {price}',
    linkedinPost: 'LinkedIn posts: {price}',
    influencerMarketingBudgetTooltip: "Your budget determines how many influencers AI can invite. Increase it if you'd like AI to match more influencers and maximize your campaign performance."
  },
  
  // 审核拒绝提醒
  reviewAlert: {
    title: 'Review Alert',
    campaignRejected: 'Campaign has been rejected',
    reviewReason: 'Review reason',
    resubmit: 'Resubmit'
  },
  
  // 充值相关
  recharge: {
    title: 'Limited Time Offer',
    description: 'Top up within 5 days of your campaign launch to get bonus ad credits. 100% refund available anytime.',
    rechargeNow: 'Deposit funds now',
    skipForNow: 'Skip for now',
    depositNow: 'Deposit {total} now, get {credits} in ad credit'
  },
  
  // 最大CPM相关
  maxCpm: {
    title: 'Maximum CPM',
    platform: 'Platform',
    price: 'Price',
    youtubeDedicated: 'YouTube Dedicated',
    youtubeIntegrated: 'YouTube Integrated',
    tiktokVideo: 'TikTok Video',
    instagramReel: 'Instagram Reel',
    instagramCarouselPost: 'Instagram Carousel Post',
    twitterPost: 'Twitter Post',
    linkedinPost: 'LinkedIn Post'
  },
  
  // 时间相关
  time: {
    currentTime: 'Current Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    progress: 'Progress',
    remainingDays: 'Remaining Days'
  },
  
  // 消息提示
  messages: {
    campaignPaused: 'Campaign paused successfully',
    campaignResumed: 'Campaign resumed successfully',
    budgetUpdated: 'Budget updated successfully',
    feedbackSubmitted: 'Feedback submitted successfully',
    operationFailed: 'Operation failed',
    pleaseWait: 'Please wait...',
    loading: 'Loading...',
    noData: 'No data available'
  },
  
  // 表单验证
  validation: {
    required: 'This field is required',
    invalidNumber: 'Please enter a valid number',
    invalidEmail: 'Please enter a valid email address',
    minLength: 'Minimum length is {min} characters',
    maxLength: 'Maximum length is {max} characters'
  },
  
  // 通用
  common: {
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    close: 'Close',
    loading: 'Loading',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    add: 'Add',
    remove: 'Remove',
    searchData: 'Search',
    filterData: 'Filter',
    sort: 'Sort',
    refresh: 'Refresh',
    exportData: 'Export',
    import: 'Import',
    downloadData: 'Download',
    upload: 'Upload'
  },
  
  // 主页面相关
  mainPage: {
    campaignCanceled: 'Campaign canceled',
    campaignCanceledDescription: 'We regret to inform you that your campaign has been canceled due to an incomplete payment. However, you can still follow up with any established collaborations. Contact support if you need any assistance.',
    fold: 'Fold',
    headInstructions: 'AhaCreator Instructions',
    headInstructionsDesc: 'What to expect after launching your campaign',
    headAcademy: 'AhaCreator Academy',
    headAcademyDesc: 'Watch full tutorials on YouTube'
  },
  

  
  // 合作页面相关
  collaboration: {
    creatorList: 'Creator List',
    invitedList: 'Invited List',
    todoList: 'Todo List',
    searchCollaboration: 'Search',
    filterCollaboration: 'Filter',
    statusCollaboration: 'Status',
    platformCollaboration: 'Platform',
    regionCollaboration: 'Region',
    languageCollaboration: 'Language',
    nameCollaboration: 'Name',
    followers: 'Followers',
    engagement: 'Engagement',
    priceCollaboration: 'Price',
    actionsCollaboration: 'Actions',
    invite: 'Invite',
    accept: 'Accept',
    reject: 'Reject',
    pendingCollaboration: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    completed: 'Completed',
    viewCollaboration: 'View',
    editCollaboration: 'Edit',
    deleteCollaboration: 'Delete',
    downloadCollaboration: 'Download',
    exportCollaboration: 'Export',
    noDataCollaboration: 'No data available',
    loadingCollaboration: 'Loading...',
    errorCollaboration: 'Error occurred',
    successCollaboration: 'Operation successful',
    // 标签页选项
    invitedInfluencers: 'Invited influencers',
    establishedCollaborations: 'Established collaborations',
    confirmInviteList: 'Confirm invite list',
    all: 'All',
    ahaPicks: 'Aha picks',
    quotedInfluencers: 'Quoted influencers',
    priceNegotiation: 'Rate negotiation',
    pendingKickoff: 'Pending kickoff',
    scriptUnderProduction: 'Script under production',
    contentUnderProduction: 'Content under production',
    pendingPublish: 'Pending publish',
    adsPublished: 'Ads published',
    canceled: 'Canceled',
    // 新增翻译键
    inviteTemplates: 'Invite templates',
    influencer: 'Influencer collabs',
    inviteEmailTemplate: {
      button: 'Invite email template',
      title: 'Invite email template',
      description: 'AhaCreator powers outreach with tens of thousands of diversified email templates. These templates have been validated across millions of real orders and consistently deliver the strongest response and conversion performance. Below are 5 invitation examples:',
      tooltip: 'After completing the influencer invitation, the email template viewing will be automatically enabled.',
    },
    trialBatchTip: 'AhaCreator has invited a trial batch of influencers, allowing you to receive 3–5 initial applications. To unlock full access, simply ',
    startCollaboration: 'start a collaboration with any creator',
    or: 'or',
    depositBudget: 'deposit your campaign budget',
    earnMoreCredits: 'to earn more credits',
    campaignProgress: {
      reviewCampaign: 'Campaign launched',
      matchInfluencers: 'Matching & inviting',
      negotiatePriceAndSettleContract: 'Influencer interest',
      viewInfluencerApplication: 'Rates & applications',
      reviewCampaignActiveDesc: 'Platform reviews your campaign within 24 business hours',
      reviewCampaignAfterDesc: 'Your campaign is live and ready for outreach',
      matchInfluencersBeforeDesc: 'Best-fit influencers will be matched and invited for you',
      haveBeenMatched: ' influencers matched · Invitations sent',
      matchInfluencersActiveDesc: 'AI is matching top influencers and sending invitations for you',
      negotiatePriceAndSettleContractBeforeDesc: 'Interested influencers will appear here',
      negotiatePriceAndSettleContractActiveDesc: ' have shown interest',
      viewInfluencerApplicationBeforeDesc: 'Influencers\' rates will be available under "Quoted Influencers" tab below.',
      viewInfluencerApplicationActiveDesc: ' submitted rates · Ready for your review',
      viewPlatformDetails: 'View platform details',
      viewApplication: 'Review rates',
    },
    ahaPicksTooltip: "Curated influencers from AhaCreator’s registered influencer pool to help you match faster.",
    pendingKickoffTooltip:
      "You have confirmed the collaboration with the following influencers. Waiting for the influencers to start content production.",
  },
  

  
  // 活动信息页面相关
  campaignInfoDetails: {
    title: 'Campaign Information',
    basicInfo: 'Basic Information',
    settings: 'Settings',
    details: 'Details',
    statusCampaignInfo: 'Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    budgetCampaignInfo: 'Budget',
    objective: 'Objective',
    target: 'Target',
    platformCampaignInfo: 'Platform',
    audience: 'Audience',
    creative: 'Creative',
    editCampaignInfo: 'Edit',
    saveCampaignInfo: 'Save',
    cancelCampaignInfo: 'Cancel',
    deleteCampaignInfo: 'Delete',
    viewCampaignInfo: 'View',
    noDataCampaignInfo: 'No data available',
    loadingCampaignInfo: 'Loading...',
    errorCampaignInfo: 'Error occurred'
  },
  


  // 活动详情面板相关
  panel: {
    reminder: 'Reminder',
    editWarning: 'Since the campaign has already launched, only certain portions of the campaign information can be edited.',
    edit: 'Edit',
    resumed: 'Resumed',
    objective: 'Objective',
    internalNote: 'Internal note',
    startedOn: 'Started on',
    currentCycle: 'Current cycle',
    editCampaign: 'Edit Campaign',
    resume: 'Resume',
    pause: 'Pause',
    paused: 'Paused',
    reject: 'Reject',
    approve: 'Approve',
    rejectTitle: 'REJECT',
    rejectCampaign: 'Reject campaign',
    rejectionReason: 'Rejection reason',
    rejectionReasonDesc: 'Please provide the advertiser with the reason for the rejection.',
    enterRejectReason: 'Please enter reject reason',
    successfully: 'successfully!'
  },

  // 最大CPM预算相关
  maxCpmBudget: {
    headerTitle: 'Raise CPM to fully use your ad budget',
    closeText: 'Maybe later',
    description: 'Your current ad spend is {cost} USD based on the existing maximum CPM settings. To fully utilize your budget, we recommend increasing the maximum CPM as follows:',
    approveChanges: 'Do you approve these changes?',
    platforms: {
      youtubeDedicated: 'YouTube dedicated videos',
      youtubeIntegrated: 'YouTube integrated videos',
      tiktokVideo: 'TikTok videos',
      instagramReel: 'Instagram Reels',
      twitterPost: 'Twitter / X posts',
      linkedinPost: 'LinkedIn posts'
    }
  },

  // 受众页面相关
  audience: {
    title: 'Audience',
    edit: 'Edit',
    mode: 'Mode',
    smartMatchMode: 'Smart match mode',
    manualMode: 'Manual mode',
    smartMatchDesc: 'Let AI agent select for you: AI agent begins by targeting top-priority audiences. As the campaign progresses, if there aren\'t sufficient influencers, AI agent will broaden the reach to include wider audiences.',
    manualModeDesc: 'Select audience manually: You can select audiences based on platform recommendations. As the campaign progresses, if there aren\'t sufficient influencers, you need to manually add more audiences.',
    showMore: 'Show more'
  },

  // 活动创意页面相关
  campaignIdeas: {
    title: 'Campaign Ideas',
    edit: 'Edit'
  },

  // 活动信息编辑页面相关
  campaignInformationEdit: {
    title: 'Campaign information',
    cancel: 'Cancel',
    save: 'Save',
    campaignName: 'Campaign name',
    internalNote: 'Internal note',
    influencerBudget: 'Influencer budget',
    affiliateRecruitmentBudget: 'Affiliate recruitment budget',
    coldEmailOutreachBudget: 'Cold email outreach budget',
    platform: 'Platform',
    country: 'Country',
    languages: 'Languages',
    influencerMarketingPostDate: 'Influencer marketing post date',
    businessName: 'Business name',
    website: 'Website',
    benchmarkBrands: 'Benchmark brands',
    productIntro: 'Product intro',
    coreSellingPoints: 'Core selling points',
    coreAudiences: 'Core product audiences',
    budgetPerInfluencer: 'Budget per Influencer',
    maximumCpm: 'Maximum CPM',
    selectAll: 'Select All',
    flexiblePostTime: 'Flexible post time: Creators can publish their content as soon as it\'s approved.',
    fixedPostTime: 'Fixed post time: Creators are required to post within a designated time window.',
    letAiAgentSetCpm: 'Let AI agent set the CPM',
    setMaximumCpmManually: 'Set maximum CPM manually',
    regenerateOptimizedAudiences: 'Regenerate optimized audiences?',
    regenerateAudiencesDesc: 'We\'ve detected changes to your campaign information that may affect your optimized audiences. Would you like to regenerate the optimized audiences now?',
    notNow: 'Not now',
    confirm: 'Confirm',
    gotIt: 'Got it',
    campaignUpdated: 'Campaign updated! We\'ll invite influencers based on your latest settings. Applications will arrive soon!',
    // 表单验证消息
    pleaseEnterCampaignName: 'Please enter campaign name',
    maximum50Characters: 'Maximum 50 characters allowed.',
    pleaseSelectBudget: 'Please select budget',
    pleaseSelectAtLeastOnePlatform: 'Please select at least one platform content type',
    pleaseSelectAtLeastOneRegion: 'Please select at least one region',
    pleaseEnterBenchmarkBrands: 'Please enter benchmark brands',
    pleaseEnterElevatorPitch: 'Please enter elevator pitch',
    pleaseSelectPostDate: 'Please select post date',
    pleaseEnterBusinessName: 'Please enter business name',
    campaignIntroduction: 'Campaign introduction',
    // 提示信息
    platformTooltip: 'Choose the social platforms and content types you would like the influencers to engage with.',
    languageTooltip: 'Enter a language to show your ads to people who use the language.',
    postDateTooltip: 'Specify if you have a particular date window in mind for when you would like the influencers to post their content.',
    benchmarkBrandsDesc: 'We\'ll recommend influencers who have worked with these brands or reached similar audiences.',
    productIntroPlaceholder: 'Please briefly describe your product\'s core value and unique points. Be concise and impactful.',
    businessNamePlaceholder: 'Please enter business name',
    benchmarkBrandsPlaceholder: 'Please enter benchmark brands',
    // 日期选择器提示
    selectCampaignStartDates: 'Select campaign start dates at least one month in advance to ensure influencers have ample time to produce content.',
    // 平台限制警告
    platformLimitWarning: 'Selected platforms may limit your campaign\'s reach. To maximize performance, please consider including more platforms.',
    recommend: 'We\'ll recommend influencers who have worked with these brands or reached similar audiences.',
    // 匹配准确度模态框
    matchingAccuracyModal: {
      switchToFocusMode: 'Switch to Focus Mode?',
      switchToMaxScaleMode: 'Switch to Max Scale Mode?',
      switchToScaleMode: 'Switch to Scale Mode?',
      focusModeDescription: 'This will narrow the influencer pool to improve match precision, which may increase costs and extend the campaign timeline. Best suited for highly niche campaigns.',
      maxScaleModeDescription: 'This will expand the influencer pool to help lower costs and accelerate campaign execution, but may reduce overall match precision. Best suited for campaigns targeting broad audiences.',
      switchToScaleFromFocusDescription: 'Switching to Scale Mode will expand the influencer pool while maintaining relevance, offering a balance between efficiency, cost, and campaign speed.',
      switchToScaleFromMaxScaleDescription: 'This will narrow the influencer pool compared to Max Scale Mode while maintaining relevance—offering a balanced trade-off across efficiency, cost, and campaign speed.',
      confirmSwitch: 'Confirm switch',
      focusModeWarning: 'Important: Switching to Focus Mode will recalculate influencer matches. Some existing invitations and applications that no longer qualify will be removed. Please proceed with caution.',
      scaleModeWarningFromMaxScale: 'Important: Switching to Scale Mode will recalculate influencer matches. Some existing invitations and applications that no longer qualify will be removed. Please proceed with caution.',
    }
  },

  // 活动信息预览页面相关
  campaignInformationPreview: {
    title: 'Campaign information',
    edit: 'Edit',
    campaignName: 'Campaign name',
    internalNote: 'Internal note',
    influencerMarketingBudget: 'Influencer marketing budget',
    affiliateRecruitmentBudget: 'Affiliate recruitment budget',
    coldEmailBudget: 'Cold email budget',
    influencerMarketingBudgetTooltip: "Your budget determines how many influencers AI can invite. Increase it if you'd like AI to match more influencers and maximize your campaign performance.",
    country: 'Country',
    language: 'Language',
    platform: 'Platform',
    placements: 'Placements',
    audienceLinkTitle: 'Provide the link where audience will be taken when they click',
    affiliateCommissionRate: 'Affiliate commission rate',
    influencerMarketingPostDate: 'Influencer marketing post date',
    affiliateMarketingPostDate: 'Affiliate marketing post date',
    fixedPostTime: 'Fixed post time: Creators are required to post within a designated time window.',
    flexiblePostTime: 'Flexible post time: Creators can publish their content as soon as it\'s approved.',
    affiliatePostTime: 'Influencers are required to post content within 7 days after their applications are approved',
    importantMatters: 'Important Matters',
    campaignResultsEstimation: 'Campaign results estimation',
    estimationDescription: 'These figures are predicted results — actual outcomes will depend on the final performance of the selected influencers.',
    businessName: 'Business name',
    website: 'Website',
    benchmarkBrands: 'Benchmark brands',
    productServiceType: 'Product / Service type',
    productIntro: 'Product intro',
    productValue: 'Product value',
    coreSellingPoints: 'Core selling points',
    coreAudiences: 'Core product audiences',
    budgetPerInfluencer: 'Budget per Influencer',
    maximumCpm: 'Maximum CPM'
  },

  influencerStrategy: {
    title: 'Influencer strategy',
    campaignBrief: 'Product link or brief you shared',
    influencerProfiles: {
      title: 'Influencer profiles',
      description:
        'Describe your ideal influencers in natural language. You can also generate profiles from product info, reference influencers, or benchmark products.',
      regenerate: 'Refine profiles',
    },
    wishlist: 'Wishlist',
  },

  creatorBrief: {
    title: 'Creator brief',
  },

  termsAndBudget: {
    title: 'Campaign budget',
    tabLabel: 'Terms & budget',
    applyUsageRightsChangesTitle: 'Apply usage rights changes?',
    applyUsageRightsChangesDesc:
      "These changes will only apply to influencers you haven't confirmed yet. Confirmed influencers keep their original terms because pricing has already been agreed.",
    confirmUpdate: 'Confirm update',
  },

  // 其他信息编辑页面相关
  otherInformationEdit: {
    title: 'Other information',
    cancel: 'Cancel',
    save: 'Save',
    coldEmailOutreach: 'Cold email outreach',
    coldEmailOutreachDesc: 'This will serve as the sender name for your cold emails',
    emailSenderName: 'Email sender name',
    emailSenderTitle: 'Email sender title',
    emailToForwardLeads: 'Email to forward converted leads',
    emailSenderNamePlaceholder: 'This will serve as sender name for your cold emails',
    emailSenderTitlePlaceholder: 'This will serve as sender\'s title for your cold emails',
    emailForwardPlaceholder: 'We will forward hot quality leads to this email',
    customBrandGuidelines: 'Custom brand guidelines',
    customBrandGuidelinesCampaignBrief: 'Custom brand guidelines / Campaign brief',
    add: 'Add',
    blocklist: 'Blocklist',
    blocklistDesc: 'Upload a list of creators you do not wish to work with.',
    downloadTemplate: 'Download template',
    upload: 'Upload',
    referenceInfluencers: 'Reference influencers',
    referenceInfluencersDesc: 'Upload a list of influencers you like, and AhaCreator will find similar ones for your campaign.',
    brandAssets: 'Brand assets',
    brandAssetsPlaceholder: 'Please enter the Brand assets link...',
    productExplainerVideo: 'Product explainer video',
    // ProductDelivery.tsx extra
    fileSizeExceed5MB: 'The file size cannot exceed 5 MB!',
    uploadProductPhotoFailed: 'Failed to upload product photo',
    pleaseSelect: 'Please select',
    pleaseEnterProductName: 'Please enter product name',
    uploadProductPhotos: 'Upload product photos',
    uploadPhotoHint: '.JPG, .JPEG, or .PNG, 5MB Max.',
    pleaseUploadProductPhotos: 'Please upload product photos',
    pleaseEnterProductCashValue: 'Please enter product cash value',
    productVideoPlaceholder: 'e.g. https://youtu.be/nXyPLFQeddA?si=EoO5X98IP5lZ1sw8',
    influencerAutoApproval: 'Influencer auto-approval',
    autoApprovalDesc: 'Influencers meeting the criteria you set will be automatically approved for content production.',
    matchingScore: 'Matching score',
    matchingScoreAbove: 'Matching score above',
    cpmBelow: 'CPM below',
    cpcBelow: 'CPC below',
    // 表单验证消息
    pleaseEnterEmailSenderName: 'Please enter email sender name',
    pleaseEnterEmailSenderTitle: 'Please enter email sender title',
    pleaseEnterEmailForward: 'Please enter email sender forward email',
    pleaseEnterValidEmail: 'Please enter a valid email address',
    pleaseInputValidLink: 'Please input Valid Link!',
    pleaseInputValidYoutubeLink: 'Please input Valid Youtube Link!',
    pleaseFillCriteriaForAllPlatforms: 'Please fill in the criteria for all platforms before submitting.',
    // 错误消息
    fileDoesNotContainInfluencerProfile: 'the file does not contain any influencer profile'
  },

  // 其他信息预览页面相关
  otherInformationPreview: {
    title: 'Other information',
    edit: 'Edit',
    productDelivery: 'Product delivery',
    iWillShipProduct: 'I will ship the product',
    noShipmentNeeded: 'No shipment needed',
    shipProductDescription: 'You will need to send products to each creator and provide necessary shipping information on the platform. Once they receive the products, they will begin creating content.',
    productName: 'Product name',
    productRetailPrice: 'Product retail price',
    productPhoto: 'Product photo',
    coldEmail: 'Cold email',
    emailSenderName: 'Email sender name',
    emailSenderTitle: 'Email sender title',
    emailToForwardLeads: 'Email to forward converted leads',
    customBrandGuidelines: 'Custom brand guidelines',
    blocklist: 'Blocklist',
    blocklistDesc: 'Upload a list of creators you do not wish to work with.',
    downloadTemplate: 'Download template',
    referenceInfluencers: 'Reference influencers',
    referenceInfluencersDesc: 'Upload a list of influencers you like, and AhaCreator will find similar ones for your campaign.',
    brandAssets: 'Brand assets',
    productExplainerVideo: 'Product explainer video',
    // ProductDelivery.tsx extra (preview page runtime)
    fileSizeExceed5MB: 'The file size cannot exceed 5 MB!',
    uploadProductPhotoFailed: 'Failed to upload product photo',
    pleaseSelect: 'Please select',
    pleaseEnterProductName: 'Please enter product name',
    uploadProductPhotos: 'Upload product photos',
    uploadPhotoHint: '.JPG, .JPEG, or .PNG, 5MB Max.',
    pleaseUploadProductPhotos: 'Please upload product photos',
    pleaseEnterProductCashValue: 'Please enter product cash value',
    productOptionsForInfluencerSelection: 'Product options for influencer selection',
    pleaseEnterProductOptions: 'Please enter product options for influencer selection',
    optionalGuidanceForInfluencerSelection: 'Optional guidance for influencer selection',
    pleaseEnterOptionalGuidance: 'Please enter optional guidance for influencer selection',
    addImage: 'Add image',
    addProductOption: 'Add product option',
    requireCreatorRegistrationDesc: 'Influencers must sign up on your product first, then provide their registered email/UID to get access.',
    influencerAutoApproval: 'Influencer auto-approval',
    autoApprovalDesc: 'Influencers meeting the criteria you set will be automatically approved for content production.',
    matchingScore: 'Matching score',
    matchingScoreAbove: 'Matching score above',
    cpmBelow: 'CPM below',
    cpcBelow: 'CPC below',
    ideaScriptSubmission: 'Idea/script submission',
    ideaScriptSubmissionDesc: 'This update applies only to new influencer collaborations. Existing collaborations that have already started cannot be updated and will continue under the original terms.',
    ideaScriptCreateText: 'If required, the influencer should submit an idea or script to align on content direction before starting production.',
    productDeliveryDescription: 'You will need to send products to each creator and provide necessary shipping information on the platform. Once they receive the products, they will begin creating content.',
    productOptionsPhoto: 'Product options photo',
    productOptionsForInfluencerSelectionDesc: 'Add product options influencers can select from (e.g. size, color, capacity)',
    optionalGuidanceForInfluencerSelectionDesc: 'Add guidance to help influencers make the right selection (e.g. sizing tips, color suggestions)',
  },

  // AI代理列表相关
  aiAgentLists: {
    reviewCampaignInfo: 'Review campaign information... Provide feedback within 24 hours',
    reviewedCampaignInfo: 'Reviewed campaign information.Campaign approved',
    matchInfluencers: 'Match influencers from influencer database with over influencers',
    matchTikTokInfluencers: 'Match TikTok influencers',
    matchTikTokBody: 'A total of TikTok influencers have been matched',
    matchYouTubeInfluencers: 'Match YouTube influencers',
    matchYouTubeBody: 'A total of YouTube influencers have been matched',
    identifyContactInfo: 'Identify influencer contact information and send invites',
    sendInvitesYouTube: 'Send invites to YouTube influencers',
    sendInvitesYouTubeBody: 'Identified contact information of YouTube influencers. invites have been sent',
    sendInvitesTT: 'Send invites to TT influencers',
    sendInvitesTTBody: 'Identified contact information of YouTube influencers. invites have been sent',
    negotiateInfluencers: 'Negotiate with interested influencers for the best price and settle influencer contract',
    negotiateWithInfluencers: 'Negotiate with influencers',
    negotiateBody: 'influencers have shown interested. AhaCreator negotiates with them for the best price',
    settleContract: 'Settle contract',
    settleContractBody: 'Settle contract with influencers who have confirmed price',
    influencersApplied: 'influencers have submitted applications. If you have any feedback on these influencers please share, so I can better match for your needs.'
  },

  // 调整提示相关
  adjustAlert: {
    description: 'You\'re currently viewing a trial batch of influencer invites. To unlock full influencer outreach, please deposit funds now.',
    adjustInputs: 'Not seeing ideal matches? Adjust your inputs.'
  },

  // 广告活动营销策略标签页相关
  adsCampaignMarketingStrategyTabs: {
    affiliatesMarketing: 'Affiliates marketing',
    influencerMarketing: 'Influencer marketing'
  },

  // 创作者列表空状态相关
  creatorListEmpty: {
    ahaPicksMessage: 'Picking the best matches from our 50K+ curated influencer pool. Almost there!',
    pendingConfirmationStartWith: 'Start with ',
    ahaPicks: 'Aha picks',
    pendingConfirmationCoreMatchDesc: ': review our curated influencers and request quotes from the ones you like. As soon as an influencer submits a quote, they\'ll appear in the Quoted influencers tab for you to review.',
    pendingConfirmationReachingOut: 'We\'re reaching out to more influencers for you right now.',
    pendingConfirmationOnceConfirm: 'Once they confirm interest and share a quote, you\'ll see them in the Quoted influencers tab for review. This usually takes around 48 hours.',
    noData: 'No data',
  },

  // 创作者列表相关
  creatorList: {
    ahaPicksConfirmTooltip: 'Request quote',
    ahaPicksInvite: 'Invite',
    ahaPicksSendOffer: 'Send offer',
    ahaPicksSendNewQuote: 'Send new quote',
    ahaPicksSendOfferSelectContentType: 'Select content type',
    ahaPicksSendOfferSelectContentTypeHint: 'You can select two content types at the same time',
    ahaPicksSendOfferContentTypeTitle: '{label} offer',
    ahaPicksContentTypeDesc: {
      instagramReel: 'A short Instagram video created to exclusively promote a brand',
      instagramCarouselPost: 'A single Instagram post featuring multiple brand photos or videos that users can swipe through',
      tiktokVideo: 'Exclusive TikTok video custom-made specifically for the brand.',
      youtubeDedicated: 'A standalone YouTube video created specifically to focus entirely on promoting the brand',
      youtubeIntegrated: 'A YouTube video that seamlessly incorporates brand promotion within your regular content',
      linkedinImagePost: 'A carousel post featuring branded visuals, infographics, or professional photos',
      linkedinVideoPost: 'A professional video post where you speak about or demonstrate the brand — such as use cases, expert opinions, or testimonials.',
      twitterPost: 'Exclusive X post custom-made specifically for the brand.',
    },
    ahaPicksRemoveTooltip: 'Remove influencer',
    depositFundsNow: 'DEPOSIT FUNDS NOW',
    moreInfluencers: 'More influencers',
    areWaitingToCollaborate: 'are waiting to collaborate — To unlock full access, simply start a',
    collaborationWithAnyCreator: 'collaboration with any creator',
    or: 'or',
    depositYourCampaignBudget: 'deposit your campaign budget.',
    unlockFullAccess: 'Unlock full access',
    notSeeingIdealMatches: 'Not seeing ideal matches?',
    adjustYourInputs: 'Adjust your inputs',
    ahaPicksAlertCoreMatchPart1: " We've found the best matches from AhaCreator's registered influencer pool so far. We're also inviting more influencers now. Once they express interest and submit a rate, you'll see them in the ",
    ahaPicksAlertQuotedInfluencers: 'Quoted influencers',
    ahaPicksAlertCoreMatchPart2: ' tab. More recommendations are on the way. Stay tuned!',
    ahaPicksAlertDefault: "This is the curated influencers recommended from AhaCreator's influencer pool. Please review this batch (request quote or remove). Once you're done, we'll keep adding new recommendations. Influencers who've shared their rates will appear in the Quoted influencers tab. ",
    ahaPicksRemoveModalTitle: "Let's fine-tune your campaign for better matches",
    ahaPicksRemoveModalContentPart1: "Thanks for reviewing your first 5+ creators. Right now the pass rate is {pass_rate}% (below 30%), which usually means we can dial in the setup a bit. You can ",
    ahaPicksRemoveModalContentHighlight: "update your campaign details, influencer profile, audience profile, or influencer filters",
    ahaPicksRemoveModalContentPart2: ", and we'll refresh recommendations right away.",
  },

  // 创作者表格列相关
  creatorTableColumns: {
    name: 'Name',
    aiRecommendationReasons: 'AI recommendation reasons',
    status: 'Status',
    matchingScore: 'Match score',
    language: 'Language',
    targetingGap: 'Targeting gap',
    placement: 'Placement',
    bestPrice: 'Proposed rate',
    recruitmentCost: 'Recruitment cost',
    commissionRate: 'Commission rate',
    lowestCpm: 'Estimated CPM',
    cpm: "CPM",
    medianCpm: "Median CPM",
    brandedContentPredictedViews: 'Median views',
    publishTime: 'Publish time',
    starred: 'Starred',
    requestedExtension: "Requested extension",
    reviewExtension: "Review extension",
    wantBetterResults: 'Want better results?',
    matchingScoreDescription: 'The Matching Score shows how well an influencer aligns with your campaign settings, and generally, a higher score leads to better results.',
    lowerPrice: 'Lower price',
    lowerPriceTooltip: 'To demonstrate a strong intent to collaborate, this influencer has voluntarily lowered their price below our suggested rate.',
    higherPriceTooltipTitle: 'Final price confirmed',
    higherPriceTooltip: 'The influencer’s price is higher than the platform guideline. Our AI agent has already negotiated and confirmed this is the lowest price they can offer.',
    betterOffer: 'Better Offer',
    betterOfferTooltip: 'The influencer has voluntarily lower their rate below their typical offer for this collaboration.',
    addFavoriteTooltip: 'Add to this campaign’s favorites',
    removeFromFavoriteTooltip: 'Remove from this campaign’s favorites',
    removeCollaborationTooltip: 'Remove collaboration',
    confirmCollaborationTooltip: 'Confirm collaboration',
    submitShippingInformationTooltip: 'Submit tracking number',
    reviewScriptTooltip: 'Review script',
    reviewDraftTooltip: "Review draft",
    lastUpdateTime: 'Last update time',
    yourOffer: 'Your offer',
    influencerCounter: 'Influencer counter',
    influencerFirstRate: 'Influencer first rate',
    historicalPriceRange: 'Historical price range',
    historicalPriceRangeTooltip: "Estimated from past collaborations (not a quote). Final rate will be confirmed in the influencer's quote.",
    openingOffer: 'Your opening offer',
    requestQuoteOrSendOffer: 'Request quote or directly send an offer',
    askedInfluencerToQuoteFirst: 'You asked the influencer to quote first',
    notes: 'Notes',
    screeningAnswers: 'Screening answers',
  },

  // 保留或移除创作者弹窗
  keepOrRemoveCreatorModal: {
    title:
      'These candidates no longer match your latest campaign requirements. Select the ones you want to keep.',
    mismatchReason: 'Mismatch reason',
    okText: 'Keep selected influencers',
    cancelText: 'Reject selected influencers',
    selectedCount: '{count} influencers selected',
  },

  // 创作者表格语言选择器相关
  creatorTableSelectorLanguage: {
    allLanguages: 'All languages',
    languages: 'Languages'
  },

  // 创作者表格姓名选择器相关
  creatorTableSelectorName: {
    searchPlaceholder: 'Search influencer name or handle'
  },

  // 创作者表格地区选择器相关
  creatorTableSelectorRegion: {
    allRegions: 'All regions',
    unknown: 'Unknown'
  },

  // 创作者表格状态选择器相关
  creatorTableSelectorStatus: {
    allStatus: 'All status',
    status: 'Status'
  },

  // 空状态组件相关
  emptyComponent: {
    enterpriseSetupMessage: 'Your email domains are being set up and warmed up right now. The warmup process typically takes 7-14 days to complete.',
    inviteTheInfluencersYouWantToWorkWith: 'Invite the influencers you want to work with',
    youveChosenToReviewInviteListBeforeSendingInvites: 'You’ve chosen to review invite list before sending invites. To keep your campaign moving smoothly, please check invite list and confirm at your earliest convenience.',
    checkNow: 'Check now',
    dontWorry: 'Don\'t worry,',
    activelySendingInvitations: 'we are actively sending invitations to influencers',
    onceConfirmed: '. Once they confirm their invitations, the influencers will be presented here.',
    normallyTakes: 'Normally, this process takes about',
    processTime: '24-48 hours',
    toComplete: ' to complete. In special cases, it may take longer, we will do our best to complete it as quickly as possible.',
    workingHardToFindMatches: 'We’re working hard to find the best influencer matches from our pool of 50K registered influencers and a database of over 5M influencers. Your matches will appear in Aha Picks very soon.'
  },

  // 邀请列表相关
  invitedList: {
    // 表格列标题
    name: 'Name',
    status: 'Status',
    country: 'Country',
    language: 'Language',
    other: 'Other',
    // 全量达人外联提示
    fullOutreachLive: 'Full influencer outreach is now live for your campaign — stay tuned for high-quality applications!',
    // 试用版提示
    depositFundsNow: 'DEPOSIT FUNDS NOW',
    moreInfluencersWaiting: 'More influencers are waiting to collaborate — To unlock full access, simply start a',
    collaborationWithCreator: 'collaboration with any creator',
    or: 'or',
    depositCampaignBudget: 'deposit your campaign budget.',
    unlockFullAccess: 'Unlock full access',
    // 调整提示
    notSeeingIdealMatches: 'Not seeing ideal matches?',
    adjustYourInputs: 'Adjust your inputs',
    // 确认邀请列表相关
    confirmInviteList: {
      confirmDeleteTitle: 'Confirm removing influencer?',
      confirmDeleteTitleMultiple: 'Confirm removing influencer(s)?',
      confirmDeleteContent: 'You’re about to remove 1 influencer from this campaign. Once removed, they will no longer receive invitations or participate in this collaboration. This action can’t be undone. Please review carefully before proceeding.',
      confirmDeleteContentMultiple: 'You’re about to remove {count} influencer(s) from this campaign. Once removed, they will no longer receive invitations or participate in this collaboration. This action can’t be undone. Please review carefully before proceeding.',
      inviteSentSuccessSingle: 'Invite have been successfully sent to 1 influencers! Once the influencers apply for the campaign, you\'ll be able to find them on the "Collaboration" page',
      inviteSentSuccessMultiple: 'Invites have been successfully sent to {count} influencers! Once the influencers apply for the campaign, you\'ll be able to find them on the "Collaboration" page',
      selectCurrentPage: 'Select current page',
      confirmAllInvitations: 'Confirm all invitations',
      confirmInvite: 'Confirm invite',
      emptyStateMessage: 'AhaCreator is working hard to review influencers for you. Once the applications are reviewed, the influencers will be presented here.',
      confirmAllInvitationsContent: 'You’re about to send invitations to {count} influencers. Once sent, this action can’t be undone. Please review carefully before proceeding.',
      confirmAllInvitationsTitle: 'Confirm sending invites?',
    }
  },

  // 企业解决方案模板模态框相关
  modalEnterpriseSolutionTemplates: {
    title: 'Invite email template samples',
    description: 'These templates have been validated through thousands of experiments and are proven to drive the highest conversion rates.',
    templateNumber: 'Template',
    subject: 'Subject:',
    emailBody: 'Email body:'
  },

  // 平台过滤器相关
  platformFilter: {
    allPlatforms: 'All platforms',
    platforms: 'Platforms'
  },

  // 达人画像过滤器相关
  influencerProfileFilter: {
    placeholder: 'Influencer profile',
    label: 'Influencer profile',
  },

  // 待办事项列表相关
  todoList: {
    title: 'Pending actions',
    all: 'All',
    congratulations: 'Congratulations, this campaign has no todo.'
  },

  // 图表报告相关
  chartsReport: {
    // 分组选项标签
    audience: 'Audience',
    platform: 'Platform',
    creative: 'Creative',
    // 空状态提示
    noDataYet: 'No data yet',
    // 视图选择
    viewBy: 'View by',
    // 选择器占位符
    selectPerson: 'Select a person',
    influencerProfile: 'Influencer profile',
  },

  // 报告页面相关
  reports: {
    // 标题和标签
    campaignPerformance: 'Campaign performance',
    report: 'Report',
    watchTutorial: 'Watch tutorial',
    // 报告类型
    campaign: 'Campaign',
    influencer: 'Influencer',
    // 操作按钮
    download: 'Download',
    // 已发布内容
    publishedContent: 'Published content',
    noPublishedContentYet: 'No published content yet',
    // 其他标签
    for: 'for',
    // 表格列标题
    creatorName: 'Name',
    orderValue: 'Order value',
    commissionValue: 'Commission value',
    orderPlacementTime: 'Order placement time',
    commissionDueTime: 'Commission due time',
    paymentTime: 'Payment time',
    status: 'Status',
    pay: 'Pay',
    adsCode: 'Ads code',
  },

  // 付款模态框相关
  paymentModal: {
    // 标题
    title: 'Payment details',
    // 付款详情
    commissionAmount: 'Commission amount',
    transactionFee: 'Transaction fee',
    transactionFeeDescription: 'This fee is dependent on your payment method and charged by the payment service provider.',
    freeCredits: 'Free credits',
    total: 'Total',
    // 按钮和操作
    confirmAndPay: 'Confirm & Pay',
    setup: 'Set up',
    notNow: 'Not now',
    // 错误和警告
    paymentFailed: 'Payment failed, please try again.',
    noAvailablePaymentMethod: 'No available payment method',
    noPaymentMethodContent: 'To proceed with confirming influencers, please add funds to your balance or connect a credit/debit card.',
    // 安全提示
    guaranteedSafe: 'Guaranteed safe & secure payment',
    poweredBy: 'Powered by'
  },

  // 报告表格相关
  reportTable: {
    // 表格类型
    actual: 'Actual',
  },

  // 报告表格头部相关
  reportTableHeader: {
    // 时间相关
    startedOn: 'Started on',
    campaignPeriod: 'Campaign Period',
    reportUpdateDate: 'Report update date',
    // 其他信息
    objective: 'Objective',
    cost: 'Cost'
  },

  // 报告表格选择器相关
  reportTableSelector: {
    // 受众选择器
    allAudiences: 'All influencer profiles',
    pleaseSelect: 'Please select',
    // 创意选择器
    allCreatives: 'All creatives',
    // 平台选择器
    allPlatforms: 'All platforms',
    selectPublishedAt: 'Publish from',
    selectPublishedAtEnd: 'Publish until',
  },

  // 销售外联页面相关
  salesOutreach: {
    // 页面标题
    title: 'Cold email',
    // 表格列标题
    email: 'Email',
    name: 'Name',
    profileHeadline: 'Profile headline',
    status: 'Status',
    emailReply: 'Email reply',
    price: 'Price',
    // 状态标签
    leadForwarded: 'Lead forwarded',
    converted: 'Converted',
    // 操作按钮
    pay: 'Pay',
    paid: 'Paid',
    // 统计信息
    leadsPurchased: 'Leads purchased',
    totalSent: 'Total sent',
    openRate: 'Open rate',
    replyRate: 'Reply rate',
    convertedCount: 'Converted',
    totalQualifiedLeads: 'Total qualified leads in the database:',
    addMoreLeads: 'Add more leads',
    // 空状态提示
    emailWarmingUp: 'Email warming up in progress. This might take up to 7 days to ensure highest outreach efficiency.',
    emailTemplatesLeverage: 'Our email templates leverage a proven track record, generating over 20,000 leads for more than 300 businesses'
  },

  // 添加更多线索模态框相关
  addMoreLeads: {
    // 模态框标题
    title: 'Add more leads',
    // 描述文本
    description: 'Additional {availableLeads} qualified leads are available. Enter the number of leads you\'d like to add.',
    // 输入框占位符
    placeholder: 'Please fill in the purchase leads quantity',
    // 错误提示
    numberMustBeGreaterThanZero: 'number must be greater than zero!',
    enterNumberSmallerThan: 'Enter a number smaller than {availableLeads}!',
    // 按钮文本
    cancel: 'Cancel',
    proceedToPayment: 'Proceed to payment'
  },

  // 邮件详情组件相关
  emailDetails: {
    // 按钮文本
    payToUnlock: 'Pay to unlock this converted lead'
  },

  // 邮件付款模态框相关
  emailPaymentModal: {
    // 默认标题
    defaultTitle: 'Cold email payment details',
    // 费用项目
    coldEmailInfra: 'Cold email infra',
    enterpriseSolutionCost: 'Enterprise solution cost',
    transactionFee: 'Transaction fee',
    freeCredits: 'Free credits',
    total: 'Total',
    // 费用说明
    coldEmailInfraDesc: 'This include basic costs including domain set up fee, emails warmup fee, email outreach fee, etc.',
    enterpriseSolutionDesc: 'This include basic costs including customized domain set up fee, customized promotional link fee, etc.',
    transactionFeeDesc: 'This fee is dependent on your payment method and charged by the payment service provider.',
    // 按钮文本
    confirmAndPay: 'Confirm & Pay',
    // 安全提示
    guaranteedSafe: 'Guaranteed safe & secure payment',
    poweredBy: 'Powered by',
    // 错误和警告
    paymentFailed: 'Payment failed, please try again.',
    // 原始价格（划线价格）
    originalPrice: 'Original price'
  },

  inviteAgain: {
    trigger: "Invite again",
    title: "Invite again",
    subtitle:
      "Add a new collaboration with {creatorName} to an existing campaign, or create a new one.",
    mobileStepCampaign: "Step 1 of 2 · Select campaign",
    mobileStepOffer: "Step 2 of 2 · Offer details",
    selectCampaign: "Select a campaign",
    selectCampaignDescription:
      "Add a new collaboration with {creatorName} to an existing campaign, or create a new one.",
    searchPlaceholder: "Search campaign name",
    createCampaign: "Create a new campaign",
    createCampaignDescription:
      "This influencer will be added automatically.",
    loadingCampaigns: "Searching campaigns...",
    searchingCampaigns: "Searching campaigns...",
    noCampaignsFound: "No campaigns found",
    noCampaignsDescription:
      "Your search did not match any campaigns. You can create a new campaign with this creator.",
    newCampaign: "New campaign",
    internalNote: "Internal note: {note}",
    budgetSpent: "{cost} / {limit} spent",
    campaignBudget: "Campaign budget: {budget}",
    pricingTitle: "Send an offer or request a quote",
    pricingDescription:
      "Choose how you would like to start this collaboration with {creatorName}.",
    sendOffer: "Send an offer",
    sendOfferDescription:
      "Send a price with the invite. {creatorName} can accept, counter, or pass.",
    selectDeliverables: "Select deliverables",
    offerLabel: "{contentType} offer",
    contentTypeDescriptions: {
      youtubeDedicated:
        "Exclusive promotional videos custom-made specifically for the brand.",
      youtubeIntegrated:
        "Videos that naturally incorporate brands or products into daily content.",
      tiktokVideo: "A TikTok video created specifically for your brand.",
      instagramReel:
        "A short Instagram Reel created specifically for your brand.",
      instagramCarouselPost:
        "A swipeable Instagram post featuring multiple branded photos or videos.",
      linkedinImagePost:
        "A professional LinkedIn image or carousel post for your brand.",
      linkedinVideoPost:
        "A professional LinkedIn video featuring your brand.",
      twitterPost: "A dedicated X post created for your brand.",
    },
    messageLabel: "Message to influencer (optional)",
    messagePlaceholder:
      "Share your reason (budget limits, simpler deliverable) and mention future collaboration opportunities",
    nonNegotiable: "Make this rate fixed (non-negotiable)",
    nonNegotiableDescription:
      "Once turned on, the influencer can only accept or decline.",
    requestQuote: "Request a quote",
    requestQuoteDescription:
      "Invite {creatorName} without a price. They send their rate first, then you accept, counter, or pass.",
    cancel: "Cancel",
    back: "Back",
    continue: "Continue",
    addToCampaign: "Add to campaign",
    success: "Invite has been successfully sent.",
    loadCampaignsFailed: "Failed to load active campaigns.",
    createCampaignFailed: "Failed to create a campaign.",
    submitFailed: "Failed to add this collaboration.",
  },

  // 议价提案相关
  proposedRate: {
    counter: 'Make counteroffer',
    negotiationPrice: 'Negotiation price',
    negotiationRecords: 'Negotiation records',
    influencerMessage: "Influencer message",
    brandMessage: "Brand message",
    makeACounterOffer: 'Make a counter offer',
    submitMyProposal: 'Submit my proposal',
    submitMyRate: 'Submit my rate',
    yourCounterOffer: "Your counter offer",
    yourLatestQuote: "Your latest quote",
    yourLatestQuoteDesc: "Your latest quote is being reviewed by the influencer. You can submit a new offer for the influencer to review.",
    price: "Price",
    editPrice: "Edit price",
    medianViews: "Median views",
    medianCpm: "Median CPM",
    belowCreatorBaselineRate: "Below this influencer's committed base rate",
    belowCreatorBaselineRateDesc: "To continue, explain why this offer should be considered as an exception.",
    explanation: "Explanation",
    explanationPlaceholder: "Help the influencer understand why this offer should be considered below their committed rate, e.g. minimal production effort, flexible delivery timeline, etc.",
    messageToInfluencer: "Message to influencer (optional)",
    messagePlaceholder: "Share your reason (budget limits, simpler deliverable) and mention future collaboration opportunities",
    nonNegotiableTooltip: "This influencer’s rate is fixed and can’t be negotiated.",
    nonBrandNegotiableTooltip: "You have marked this offer as non-negotiable. The influencer may accept or decline it, but cannot negotiate further.",
    negotiatedPriceTooltip: 'Price negotiation available for this influencer.',
    newLabel: 'NEW!',
    nonNegotiableCheckbox: 'Check this if your rate is non-negotiable, after checking, the influencer can only agree or refuse, please operate with caution.',
    explanationRequired: "Explanation required to proceed",
    warningAlert: "This offer is much lower than the influencer’s rate. Offers closer to their rate are more likely to be accepted.",
    errorAlert: 'Offers far from the influencer’s rate are less likely to be accepted.',
    priceHistory: 'Price history',
    makeOfferNonNegotiable: 'Make this offer non-negotiable',
    makeOfferNonNegotiableDesc: 'The influencer can only accept or decline this offer.',
    brandQuote: 'Brand quote',
    influencerQuote: 'Influencer quote',
    influencerLatestQuote: 'Influencer latest quote',
    minPriceError:
      "That's above {influencerName}'s quote of {maxPrice}. No need to offer more. Enter up to {maxPrice}.",
    allowedRangeError:
      "Enter an amount between your last offer ({lastOfferPrice}) and {influencerName}'s latest quote ({influencerQuotePrice}).",
    belowMinPriceError: "Input must be greater than {minPrice}",
    belowFairRangeAlert: 'Your offer is below the fair range. The creator may decline or counter back.',
    withinFairRangeAlert: 'Your offer sits within the fair range. A balanced number with a good chance of closing.',
    aboveFairRangeAlert: `Above the fair price for similar creators. Confirm it's within your budget before you decide.`,
    fairRangeTooltip: "The fair price range is the market rate to work with this creator. It's estimated from recent deals by similar creators, factoring in their audience, niche, channel performance (e.g.average views, follower counts), and how well this influencer fits your brand. Offering within this range gives you a strong chance of closing the deal.",
    fairRangeEstimateLink: 'How we estimate fair price range',
    fairRangeDrawerDescription: "The fair price range is the market rate for this deal. It's estimated from recent deals by similar creators, factoring in your audience, niche, channel performance (e.g.average views, follower counts), and how well you fit this brand. Pricing within this range makes sure you're paid what your work is worth while keeping your chance of landing the collaboration as high as possible.",
    nonNegotiableLabel: 'Non-negotiable',
    nonNegotiableAlert: 'This rate is non-negotiable. You can accept or decline.',
    creatorNonNegotiableAlert:
      'The influencer set this rate as non-negotiable. You can accept or decline, but not counter.',
    brandNonNegotiableAlert:
      'You set this rate as non-negotiable. The influencer can accept or decline, but not counter.',
    influencerFixedRate: 'Influencer fixed rate',
    brandFixedRate: 'Brand fixed rate',
    belowFairRangeLabel: 'Below fair range',
    withinFairRangeLabel: 'Within fair range',
    withinFairRangeLowLabel: 'Low end of fair range',
    withinFairRangeHighLabel: 'High end of fair range',
    aboveFairRangeLabel: 'Above fair range',
    creatorBelowFairRangeTooltip: "Below the fair market range, which usually means the creator is keen on your brand. A strong deal, and we'd recommend accepting.",
    creatorWithinFairRangeLowTooltip: 'Fairly priced and good to go. We suggest accepting',
    creatorWithinFairRangeHighTooltip: 'Within the fair range, a solid deal worth accepting. Negotiating further is up to you.',
    creatorAboveFairRangeTooltip: 'Priced above the fair market range. Worth a look before you decide.',
    viewDetails: 'View details',
  },

  // 报价上限相关
  rateCap: {
    overYourCap: 'Over your cap',
    overUnitPriceCap: 'Over unit price cap: {cap}',
    overCpmCap: 'Over CPM cap: {cap}',
    farAboveMarket: 'Far above market',
    withinRateCap: 'Meets criteria',
    overRateCap: 'Over rate cap',
    audienceGap: 'Audience gap',
    overRateCapAlert: 'Strong matches who quoted just above your price/CPM cap. Approve to bring them on, or pass.',
    audienceGapAlert: 'These influencers applied with strong interest, but their audience only partly matches your targeting. Check the gap below, then approve or pass at your discretion.',
  }
};
